import { SubsResources } from './subscription';
import { AdminUserResources } from './user';
import { ShopResources } from './shop';
import { ProductResources } from './product';
import { NewsResources } from './news';
import { NotificationResources } from './notification';
import { AdvancedFunctionResources } from './advancedFunction';
import { EPaymentResources } from './e_payment';

export default [
  ...AdminUserResources,
  ...SubsResources,
  ...ShopResources,
  ...ProductResources,
  ...NewsResources,
  ...NotificationResources,
  ...AdvancedFunctionResources,
  ...EPaymentResources,
];


// WEBPACK FOOTER //
// ./src/routes/resources.js